var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('v-head'),_c('v-menu'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{on:{"fnTabName":_vm.fnTabName}})],1):_c('router-view',{on:{"fnTabName":_vm.fnTabName}})],1)],1),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }